import React from 'react';
import { useSelector } from 'hooks';

import { isFlowTypeModalVisible } from 'modules/selfServices/selectors';

import Verify from './Verify';
import FlowTypeModal from '../ui/FlowTypeModal';

import type PageBaseProps from '../../types/PageBase';
import { getMFAData } from 'modules/auth/selectors';

const LoginVerify: React.FC<PageBaseProps> = (props) => {
  const isFlowTypeModalOpen = useSelector(isFlowTypeModalVisible);
  const mfaData = useSelector(getMFAData);

  return (
    <>
      {mfaData && <Verify {...props} />}
      {isFlowTypeModalOpen && <FlowTypeModal />}
    </>
  );
};

export default LoginVerify;
